var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowPinButton)?_c('Button',{attrs:{"sm":""},on:{"click":_vm.onClickPin}},[(_vm.isPinned)?[_c('IconPinned'),_vm._v(" 解除 ")]:[_c('IconPin'),_vm._v(" ピン留め ")]],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }